<template>
    <section id="update-payment-method">
        <div class="row" v-if="showAvailablePaymentMethodsBox">
            <div class="col-12" v-if="availablePaymentMethods && availablePaymentMethods.length > 0">
                <strong>{{ $t('co.payment_methods.existing.title') }}</strong>

                <b-form-radio
                    :key="pm.id"
                    v-for="pm in availablePaymentMethods"
                    name="payment-method"
                    :value="pm.id"
                    v-model="selectedPaymentMethod"
                    class="pt-3"
                >
                    <stripe-card-info :selectedPaymentMethod="pm" v-if="pm.type === 'card'"></stripe-card-info>
                    <stripe-sepa-info :selectedPaymentMethod="pm" v-if="pm.type === 'sepa_debit'"></stripe-sepa-info>
                </b-form-radio>

            </div>
            <div class="col-12 d-flex justify-content-end mt-3">
                <button class="btn btn-link" type="button" @click="showAddPaymentMethod">
                    {{ $t("co.payment_methods.button.add-payment-method") }}
                </button>
                <button type="button" @click="submit" class="btn btn-primary btn-mobile-full-width" v-if="selectedPaymentMethod && !isSubmitting">
                    {{ $t("co.button.continue") }}
                </button>
                <button type="button" class="btn btn-primary btn-mobile-full-width disabled" v-if="isSubmitting">{{$t('co.button.loading')}}</button>
            </div>
        </div>

        <div class="row" v-if="showAddPaymentMethodBox">
            <div class="col-12">
                <strong>{{ $t('co.payment_methods.new.title') }}</strong>

                <div class="mt-3" id="stripe-payment-element"></div>
                <div id="stripe-payment-errors" class="text-warning" v-if="stripe.error">
                    {{ stripe.error }}
                </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
                <button class="btn btn-link" type="button" @click="showAvailablePaymentMethods">
                    {{ $t("co.payment_methods.button.cancel-new-payment-method") }}
                </button>
                <button class="btn btn-primary" type="button" @click="handleStripeSubmit" v-if="!isSubmitting">
                    {{ $t("co.payment_methods.button.save-new-payment-method") }}
                </button>
                <button class="btn btn-primary disabled" v-else>
                    {{$t('co.button.loading')}}
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import { BFormRadio } from 'bootstrap-vue'
import StripeCardInfo from "./../atoms/StripeCardInfo.vue"
import StripeSepaInfo from "./../atoms/StripeSepaInfo.vue"
import {EventBus} from '../../event-bus.js'


export default {
    name: 'UpdatePaymentMethod',
    components: {
        BFormRadio,
        StripeCardInfo, StripeSepaInfo
    },
    props: {
        subscription: {
            type: Object
        },
        product: {
            type: Object
        }
    },
    data() {
        return {
            availablePaymentMethods: [],
            showAddPaymentMethodBox: false,
            showAvailablePaymentMethodsBox: true,
            selectedPaymentMethod: null,
            isSubmitting: false,
            stripe: {
                instance: null,
                elements: null,
                paymentElement: null,
                appearance: {}, // https://stripe.com/docs/stripe-js/appearance-api
                error: null
            }
        }
    },
    methods: {
        loadAvailablePaymentMethods() {
            this.$axios.get('api/v1/payment_methods/available_payment_methods/', { params: { subscription: this.subscription.uuid } })
                .then(response => {
                    this.availablePaymentMethods = response.data.availablePaymentMethods
                })
                .catch(error => {
                    this.availablePaymentMethods = []
                });
        },
        submit() {
            this.isSubmitting = true
            const callback = () => { this.isSubmitting = false }
            EventBus.$emit('payment-method-selected', this.selectedPaymentMethod, callback)
        },
        showAddPaymentMethod() {
            let methods = ['card']
            if(this.$root.whitelabel.setting('show_sepa')) {
                methods.push('sepa_debit')
            }

            this.$axios.post('api/v1/payment_methods/create_setup_intent', {
                paymentMethods: methods,
                subscription_uuid: this.subscription.uuid
            }).then(response => {
                const data = this.$root.stripe.getStripeData()
                this.stripe.instance = data.stripe
                this.stripe.elements = this.stripe.instance.elements({
                    clientSecret: response.data.setupIntent.client_secret,
                    appearance: this.stripe.appearance
                })
                // this.stripeStyles = data.styles
                this.stripe.paymentElement = this.stripe.elements.create('payment')
                this.stripe.paymentElement.mount('#stripe-payment-element')
            }).catch(error => {
                this.stripe.error = error.message
            })

            this.showAvailablePaymentMethodsBox = false
            this.showAddPaymentMethodBox = true
        },
        handleStripeSubmit() {
            // Handles the submit of the Stripe payment element form
            const getUrl = window.location;
            const baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
            const callbackUrl = baseUrl + "api/v1/stripe/verify-payment-method" + "?uuid=" + this.subscription.uuid
            this.isSubmitting = true

            this.stripe.instance.confirmSetup({
                elements: this.stripe.elements,
                redirect: "if_required",
                confirmParams: {
                    return_url: callbackUrl
                }
            }).then(response => {
                this.$axios.post("api/v1/payment_methods/attach", {
                    payment_method: response.setupIntent.payment_method,
                    subscription_uuid: this.subscription.uuid
                }).then(response2 => {
                    this.selectedPaymentMethod = response.setupIntent.payment_method
                    this.availablePaymentMethods = response2.data.availablePaymentMethods
                    this.isSubmitting = false

                    this.showAvailablePaymentMethods()
                }).catch(error => {
                    this.isSubmitting = false
                    this.stripe.error = error.message
                })


            }).catch(error => {
                this.isSubmitting = false
                this.stripe.error = this.$t('co.conclusion.paymentData_error');
            })
        },
        showAvailablePaymentMethods() {
            // Show the list with available PaymentMethods
            this.showAvailablePaymentMethodsBox = true
            this.showAddPaymentMethodBox = false
        }
    },
    mounted() {
        this.loadAvailablePaymentMethods()

        // If present, set the given payment method as already selected
        if(this.subscription.stripe_source !== null) {
            this.selectedPaymentMethod = this.subscription.stripe_source
        }
    },
    googleAnalyticsPaymentEvent() {
        if (process.env.MIX_VUE_APP_ACTIVATE_GOOGLE_ANALYTICS && this.$gtag !== undefined) {
            this.$gtag.event('add_payment_info', {
                currency: this.entry.price_plan.currency.toUpperCase(),
                payment_type: this.finalPaymentMethod,
                items: [
                    {
                        item_id: this.product.id,
                        item_name: this.product.model.title,
                        item_brand: this.product.brand.title,
                        item_category: this.product.category.title,
                        subsidiary_id: this.$root.whitelabel.sub_id(),
                        price: this.entry.price_plan.price,
                        mileage: localStorage.selectedMileage,
                        duration: localStorage.selectedDuration
                    }
                ]
            })
        }
    },
}
</script>
